module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-tanomail-new"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_tanomail_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Tanomail')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Tanomail New')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Tanomail New')))]), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.shop_name')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopId),
      expression: "shopId"
    }],
    staticClass: "form-control margin-right",
    on: {
      "change": function($event) {
        _vm.shopId = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("店舗を選択してください")]), _vm._l((_vm.shops), function(shop) {
    return _c('option', {
      domProps: {
        "value": shop.id
      }
    }, [_vm._v(_vm._s(shop.attributes['shop-name']))])
  })], 2), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_id),
      expression: "!validation.shop_id"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.represent_code')))]), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.represent_code))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.group_code')))]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group_code),
      expression: "group_code"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.group_code
    },
    attrs: {
      "type": "text",
      "placeholder": "例：7000272280",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.group_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group_code = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.group_code),
      expression: "!validation.group_code"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.login_id')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_id),
      expression: "login_id"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.login_id
    },
    attrs: {
      "type": "text",
      "placeholder": "例：78134567",
      "maxlength": "15"
    },
    domProps: {
      "value": _vm._s(_vm.login_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_id = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.login_id),
      expression: "!validation.login_id"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.password')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.password
    },
    attrs: {
      "type": "text",
      "placeholder": "例：aaa1111",
      "maxlength": "15"
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.password),
      expression: "!validation.password"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.management_number')))]), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.management_number))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('tanomail.label.receive_responsible')))]), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('span', [_vm._v(_vm._s(_vm.receive_responsible))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validationAll
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1374d493!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-tanomail-new.pug
// module id = 786
// module chunks = 1